import { createBrowserRouter } from 'react-router-dom';
import { Navigate, RouteObject } from 'react-router';

import { AppLayout } from 'shared/layouts';
import { ProtectedRoute } from 'shared/ui/ProtectedRoute';
import { NotFoundPage } from 'features/common/pages';
import CommunityFeature from 'features/communities';
import Crm from 'features/crm/routes';
import AuthFeature from 'features/auth';
import SubscriptionFeature from 'features/subscriptions';
import UserFeature from 'features/user';
import { LandingLayout } from 'shared/layouts/LandingLayout/LandingLayout';
import { AnalyticsPage } from 'features/analytics/pages/AnalyticsPage';
import { PublicLayout } from 'shared/layouts/PublicLayout';
import Courses from 'features/courses';
import { LandingMarketPlaceLayout } from 'shared/layouts/LandingMarketPlace/LandingMarketPlaceLayout';

import { CategoryListContainer } from './features/communities/components/Categories/container/public/CategoryListContainer';
import { QuestionContainer } from './features/communities/components/Questions/containers/public/QuestionContainer';
import { QuestionTableContainer } from './features/communities/components/Questions/containers/public/QuestionTableContainer';
import { CategoryContainer } from './features/communities/components/Categories/container/public/CategoryContainer';
import {
    MonetizationPublicRoutes,
    MonetizationRoutes,
} from './features/monetization/routes';
import { PayLayout } from './shared/layouts/PayLayout';
import Shops from './features/shops';
import AdminFeature from './features/admin';
import UserAgreement from './shared/layouts/PublicLayout/pages/UserAgreement';
import PersonalDataPolicy from './shared/layouts/PublicLayout/pages/PersonalDataPolicy';
import PersonalDataAgreement from './shared/layouts/PublicLayout/pages/PersonalDataAgreement';
import PaymentsRules from './shared/layouts/PublicLayout/pages/PaymentsRules';
import Oferta from './shared/layouts/PublicLayout/pages/Oferta';
import DeleteAccount from './shared/layouts/PublicLayout/pages/DeleteAccount';
import YookassaConnectContainer from './features/shops/features/payments/components/yookassa/YookassaConnectContainer';
import { Subscription } from './features/subscriptions/components/Subscription';
import { LegalHandler } from './features/subscriptions/components/Legal/LegalHandler';
import { PayPending } from './features/subscriptions/components/PayPending';
import { OldLandingLayout } from './shared/layouts/OldLandingLayout/LandingLayout';
import { ShopPublicRedirectContainer } from './features/shops/features/shops/containers/ShopPublicRedirectContainer';

export const routes: RouteObject[] = [
    {
        path: '/pay',
        element: (
            <ProtectedRoute>
                <PayLayout />
            </ProtectedRoute>
        ),
        children: [
            { index: true, path: 'subscription', element: <Subscription /> },
            { path: 'legal', element: <LegalHandler /> },
            { path: 'pending', element: <PayPending /> },
        ],
    },
    {
        path: '/',
        element: <LandingLayout />,
    },
    {
        path: '/landing',
        element: <OldLandingLayout />,
    },
    {
        path: '/mp',
        element: <LandingMarketPlaceLayout />,
    },

    {
        path: '/user_agreement',
        element: <PublicLayout />,
        children: [
            {
                path: '',
                element: <UserAgreement />,
            },
        ],
    },
    {
        path: '/privacy_policy',
        element: <PublicLayout />,
        children: [
            {
                path: '',
                element: <PersonalDataPolicy />,
            },
        ],
    },
    {
        path: '/personal-data-agreement',
        element: <PublicLayout />,
        children: [
            {
                path: '',
                element: <PersonalDataAgreement />,
            },
        ],
    },
    {
        path: '/payment_rules',
        element: <PublicLayout />,
        children: [
            {
                path: '',
                element: <PaymentsRules />,
            },
        ],
    },
    {
        path: '/public/shop/:id',
        element: <PublicLayout />,
        children: [
            {
                path: '',
                element: <ShopPublicRedirectContainer />,
            },
        ],
    },
    {
        path: '/oferta',
        element: <PublicLayout />,
        children: [
            {
                path: '',
                element: <Oferta />,
            },
        ],
    },
    {
        path: '/delete_account',
        element: <PublicLayout />,
        children: [
            {
                path: '',
                element: <DeleteAccount />,
            },
        ],
    },
    {
        path: '/ukassa',
        element: <PublicLayout />,
        children: [
            {
                path: 'status',
                element: <YookassaConnectContainer />,
            },
        ],
    },
    ...AuthFeature.routes,
    ...Courses.routes,

    {
        path: '/app/public',
        element: <PublicLayout />,
        children: [
            {
                path: 'knowledge-base',
                children: [
                    {
                        path: ':id',
                        element: <CategoryContainer />,
                        children: [
                            {
                                path: 'categories',
                                element: <CategoryListContainer />,
                            },
                            {
                                path: 'questions',
                                element: <QuestionTableContainer />,
                            },
                            {
                                path: 'question/:id',
                                element: <QuestionContainer />,
                            },
                        ],
                    },
                ],
            },
            ...MonetizationPublicRoutes,
        ],
    },

    {
        path: '/app',
        element: (
            <ProtectedRoute>
                <AppLayout />
            </ProtectedRoute>
        ),
        children: [
            {
                path: '',
                element: <Navigate to={'/pay/subscription'} />,
                // element: <Navigate to={CommunityFeature.routes[0].path} />,
            },
            ...UserFeature.routes,
            ...SubscriptionFeature.routes,
            ...CommunityFeature.routes,
            ...Shops.routes,
            ...AdminFeature.routes,
            ...Crm,

            ...MonetizationRoutes,

            {
                path: 'analitycs',
                element: <AnalyticsPage />,
            },
            {
                path: '*',
                element: <NotFoundPage />,
            },
        ],
    },
];

export const router = createBrowserRouter(routes);
